<div class="mx-auto px-4 mb-4">
  <div class="mb-2">
    <p class="titre1 mt-4">{{ 'USERS_MANAGEMENT.USERS_MANAGEMENT' | translate }}</p>
  </div>

  @if (isLoadingContext) {
    <div class="flex justify-center items-center min-h-[80vh]">
      <mat-spinner color="accent"></mat-spinner>
    </div>
  }

  @if (!isLoadingContext) {
    <div class="overflow-x-auto">
      <div class="mb-4 mt-2 flex items-center gap-4">
        <div class="relative w-11/12">
          <input type="text" [(ngModel)]="searchTerm" (keyup.enter)="applySearch()"
            placeholder="{{ 'USERS_MANAGEMENT.SEARCH' | translate }}..."
            class="w-full ml-4 border border-red-600 rounded-buttonAction px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-500">
            <span class="text-sm text-gray-500 ml-4 mt-1 absolute -bottom-6 left-0">
              {{ 'USERS_MANAGEMENT.MIN_CHARS_HINT' | translate }}
            </span>
          </div>
          <div class="flex items-center gap-2">
            <input type="checkbox" id="includeInvitations" [(ngModel)]="includeInvitations" (change)="applyFilters()"
              class="form-checkbox h-5 w-5 text-red-600">
              <label for="includeInvitations">
                {{ 'USERS_MANAGEMENT.INCLUDE_INVITATIONS' | translate }}
              </label>
            </div>
          </div>
          @if (isLoading) {
            <div class="relative flex justify-center items-center min-h-[200px]">
              <mat-spinner color="accent"></mat-spinner>
            </div>
          }
          @if (!isLoading) {
            @if (filteredUtilisateurs.length > 0) {
              <div>
                <table mat-table [dataSource]="dataSource" matSort class="mat-table-novo"
                  (matSortChange)="sortDataChange($event)">
                  <ng-container matColumnDef="nom">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-1/5 px-4 py-2"> {{
                    'USERS_MANAGEMENT.NAME' | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="table-cell w-1/5 px-4 py-2 border-b">
                      @if (element.estInvitationEnAttente) {
                        <i>{{ 'USERS_MANAGEMENT.PENDING_INVITATION' | translate }}</i>
                      } @else {
                        {{ element.nom }}
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-2/5 px-4 py-2">{{
                    'USERS_MANAGEMENT.EMAIL' | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="table-cell w-2/5 px-4 py-2 border-b">
                      {{ element.email }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-1/5 px-4 py-2">{{
                    'USERS_MANAGEMENT.ROLE_COMPANY' | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="table-cell w-1/5 px-4 py-2 border-b">
                      @if (!element.estActif) {
                        {{ utilisateurService.obtenirNomEntite(element.entiteId) }}
                      }
                      @if (element.estActif) {
                        @for (roleEntite of element.tousLesRolesEntites; track roleEntite) {
                          <div class="mb-1">
                            <span class="text-sm font-medium text-white">
                              {{ utilisateurService.obtenirDenominationRole(roleEntite.roleId) |
                              translate }} -
                            </span>
                            <span class="text-sm text-white">
                              {{ roleEntite.nomEntite }}
                              @if (roleEntite.idUnique) {
                                ({{ roleEntite.idUnique
                                }})
                              }
                            </span>
                          </div>
                        }
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="dateDerniereConnexion">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-3/10 px-4 py-2">{{
                    'USERS_MANAGEMENT.LAST_CONNECTION_DATE' | translate }}</th>
                    <td mat-cell *matCellDef="let element" class="table-cell w-3/10 px-4 py-2 border-b text-center">
                      {{ element.dateDerniereConnexion | customDateHeure }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell class="table-cell w-1/10 px-4 py-2" *matHeaderCellDef>{{ 'USERS_MANAGEMENT.ACTIONS' |
                    translate }}</th>
                    <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b text-center">
                      <button (click)="moveUser(element)" mat-icon-button
                        class="text-black-500 hover:text-red-700 transform scale-90 sm:scale-100">
                        <mat-icon class="material-icons-outlined">
                          swap_horiz
                        </mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                  [ngClass]="{'ligne-gray': !element.estActif}"></tr>
                </table>
                @if (dataSource.filteredData.length === 0) {
                  <div class="text-center mt-2 text-gray-500">
                    {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
                  </div>
                }
                <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
                  (page)="paginer($event)" [length]="totalItems" [showFirstLastButtons]="true">
                </mat-paginator>
              </div>
            } @else {
              <div class="text-center text-gray-600 py-8">
                {{ 'USERS_MANAGEMENT.NO_RESULTS' | translate }}
              </div>
            }
          }
        </div>
      }
    </div>